import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_DARK_PLUM, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT, PROMETHEAN_SUCCESS_GREEN, PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_BLUE, PROMETHEAN_FOCUS_SHADOW, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_TEXT_INPUT_LABEL, PROMETHEAN_TEXT_HEADER, PROMETHEAN_DARK_PURPLE, PROMETHEAN_NEUTRAL_GREY_700 } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_02, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT } from '../styles/typography/typography';
import { prometheanFont } from '../styles/font/font';
var BASIC_BORDER = '1px solid ' + PROMETHEAN_NEUTRAL_GREY_700;
var FOCUS_BORDER = '2px solid ' + PROMETHEAN_BLUE;
var ACTIVE_BORDER = '1px solid ' + PROMETHEAN_PURPLE_GRAPE;
var SUCCESS_BORDER = '1px solid ' + PROMETHEAN_SUCCESS_GREEN;
var ERROR_BORDER = '1px solid ' + PROMETHEAN_ERROR_OR_DESTRUCT;
var DISABLED_BORDER = '1px solid ' + PROMETHEAN_NEUTRAL_DARK_GREY;
var AUTOFILL_SHADOW = '0 0 0 30px white inset !important';
var BASIC_BORDER_DARK = '2px solid ' + PROMETHEAN_NEUTRAL_DARK_PLUM;
var ACTIVE_BORDER_DARK = '2px solid ' + PROMETHEAN_PURPLE_GRAPE;
var SUCCESS_BORDER_DARK = '2px solid ' + PROMETHEAN_SUCCESS_GREEN;
var ERROR_BORDER_DARK = '2px solid ' + PROMETHEAN_ERROR_OR_DESTRUCT;
var DISABLED_BORDER_DARK = '2px solid ' + PROMETHEAN_NEUTRAL_DARK_GREY;
var FOCUS_BORDER_DARK = '2px solid ' + PROMETHEAN_NEUTRAL_WHITE;
var FOCUS_INNER_BORDER_DARK = '1px solid ' + PROMETHEAN_DARK_PURPLE;
export var INPUT_LABEL_SHRINK_FACTOR = 0.75;
export var inputTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // the following seems to fix a bug in Safari
          //  where it fails to show the notch in the outline sometimes
          legend: {
            overflow: 'visible'
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: BASIC_BORDER
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: BASIC_BORDER
          },
          fontFamily: prometheanFont,
          input: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
            color: PROMETHEAN_TEXT,
            opacity: 0.76,
            '&.Mui-disabled': {
              WebkitTextFillColor: PROMETHEAN_NEUTRAL_DARK_GREY
            },
            height: 24,
            padding: '12px 16px 12px 16px',
            '&:-webkit-autofill': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:hover': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:focus': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:active': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&::placeholder': {
              color: PROMETHEAN_TEXT,
              opacity: 0.76
            }
          }),
          '&.EmbersInput-hasInput': {
            color: PROMETHEAN_TEXT_HEADER
          },
          '&.MuiInputBase-multiline': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
            color: PROMETHEAN_TEXT_HEADER,
            padding: '12px 16px 12px 16px'
          }),
          textarea: {
            color: PROMETHEAN_TEXT,
            opacity: 0.76,
            '&.Mui-disabled': {
              WebkitTextFillColor: PROMETHEAN_NEUTRAL_DARK_GREY
            },
            '&:-webkit-autofill': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:hover': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:focus': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:active': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            }
          },
          '&.MuiInputBase-adornedEnd': {
            paddingRight: 12
          },
          '[class^="icon-visibility"]': {
            cursor: 'pointer',
            color: PROMETHEAN_TEXT,
            outline: 'none',
            borderRadius: 0,
            '&:focus-visible': {
              boxShadow: PROMETHEAN_FOCUS_SHADOW
            }
          },
          // success
          '&.MuiInputBase-colorSuccess': {
            '.MuiOutlinedInput-notchedOutline': {
              border: SUCCESS_BORDER
            }
          },
          // error
          '&.MuiInputBase-colorError': {
            '.MuiOutlinedInput-notchedOutline': {
              border: ERROR_BORDER
            }
          },
          // disabled
          '&.Mui-disabled': {
            '.MuiOutlinedInput-notchedOutline': {
              border: DISABLED_BORDER
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: DISABLED_BORDER
            },
            '[class^="icon-"]': {
              pointerEvents: 'none',
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '&.EmbersInput-hasLabel': {
            marginTop: 7 // space for label
          },
          // MuiFilledInput is not working
          '&.EmbersInput-hasInput': {
            input: {
              color: PROMETHEAN_TEXT_HEADER,
              opacity: 1
            },
            textArea: {
              color: PROMETHEAN_TEXT_HEADER,
              opacity: 1
            }
          },
          '&.EmbersInput-endAdornment .MuiFormLabel-root': {
            maxWidth: 'calc(100% - 56px)'
          },
          '&.EmbersInput-endAdornment .MuiFormLabel-root.MuiInputLabel-shrink': {
            maxWidth: 'calc(133% - 24px)'
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          minHeight: '48px',
          backgroundColor: "".concat(PROMETHEAN_NEUTRAL_WHITE, " !important"),
          border: BASIC_BORDER_DARK,
          borderRadius: 4,
          input: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
            color: PROMETHEAN_TEXT_HEADER,
            '&.Mui-disabled': {
              WebkitTextFillColor: PROMETHEAN_NEUTRAL_DARK_GREY
            },
            height: 24,
            padding: '15px 14px 5px 14px',
            borderRadius: 4,
            '&:-webkit-autofill': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:hover': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:focus': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            },
            '&:-webkit-autofill:active': {
              WebkitBoxShadow: AUTOFILL_SHADOW
            }
          }),
          '&.MuiInputBase-multiline': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
            color: PROMETHEAN_TEXT_HEADER,
            textarea: {
              '&.Mui-disabled': {
                WebkitTextFillColor: PROMETHEAN_NEUTRAL_DARK_GREY
              }
            },
            height: 128
          }),
          '&::before': {
            borderBottom: 'none !important'
          },
          '&::after': {
            borderBottom: 'none !important'
          },
          // success
          '&.MuiInputBase-colorSuccess': {
            border: SUCCESS_BORDER_DARK
          },
          // error
          '&.MuiInputBase-colorError': {
            border: ERROR_BORDER_DARK
          },
          // disabled
          '&.Mui-disabled': {
            border: DISABLED_BORDER_DARK,
            '[class^="icon-"]': {
              pointerEvents: 'none',
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          },
          '[class^="icon-visibility"]': {
            cursor: 'pointer',
            color: PROMETHEAN_TEXT,
            outline: 'none',
            borderRadius: 0,
            '&:focus-visible': {
              boxShadow: PROMETHEAN_FOCUS_SHADOW
            }
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
          transform: 'translate(16px, 12px) scale(1)',
          '&.MuiInputLabel-shrink': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
            // the real size should zoom in with INPUT_LABEL_SHRINK_FACTOR to match design
            lineHeight: "".concat(20 / INPUT_LABEL_SHRINK_FACTOR, "px"),
            transform: "translate(15px, -7px) scale(".concat(INPUT_LABEL_SHRINK_FACTOR, ")"),
            '.EmbersInput-label-requiredPostfix': {
              paddingTop: 5
            }
          }),
          '&:not(&.MuiInputLabel-shrink):not(&.Mui-disabled)': {
            color: PROMETHEAN_TEXT_INPUT_LABEL
          },
          '&.Mui-disabled': {
            color: PROMETHEAN_NEUTRAL_DARK_GREY
          },
          '&.EmbersInput-label-dark': {
            '&.MuiInputLabel-shrink': {
              // the real size should zoom in with INPUT_LABEL_SHRINK_FACTOR to match design
              fontSize: "".concat(10 / INPUT_LABEL_SHRINK_FACTOR, "px"),
              lineHeight: "".concat(16 / INPUT_LABEL_SHRINK_FACTOR, "px"),
              transform: "translate(15px, 3px) scale(".concat(INPUT_LABEL_SHRINK_FACTOR, ")")
            }
          },
          '&:has(.EmbersInput-label-requiredPostfix)': {
            display: 'flex'
          },
          '.EmbersInput-label-requiredPostfix': {
            color: PROMETHEAN_ERROR_OR_DESTRUCT,
            lineHeight: '14px',
            paddingTop: 4
          }
        })
      }
    },
    MuiFormHelperText: {
      defaultProps: {
        component: 'div'
      },
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
          marginTop: 4,
          marginLeft: 16,
          marginRight: 8,
          '.EmbersInput-helperText-root': {
            display: 'flex',
            justifyContent: 'space-between',
            '.EmbersInput-helperText-content': {
              display: 'flex',
              flexDirection: 'column',
              rowGap: 8
            }
          },
          '.EmbersInput-helperText-dark': {
            color: PROMETHEAN_NEUTRAL_WHITE
          },
          '&.Mui-disabled': {
            color: PROMETHEAN_NEUTRAL_DARK_GREY
          }
        })
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          // focus by mouse
          '&.EmbersInput-clickFocus': {
            '& .Mui-focused': {
              '&:not(.MuiInputBase-colorError,.MuiInputBase-colorSuccess)': {
                '.MuiOutlinedInput-notchedOutline': {
                  border: ACTIVE_BORDER
                }
              }
            },
            '&:not(.EmbersInput-dark.EmbersInput-mini)': {
              '.MuiFilledInput-root': {
                '&:not(.MuiInputBase-colorError,.MuiInputBase-colorSuccess)': {
                  '&.Mui-focused': {
                    border: ACTIVE_BORDER_DARK
                  }
                }
              }
            }
          },
          // focus by keyboard
          '&:not(.EmbersInput-clickFocus)': {
            '& .Mui-focused': {
              '&:not(.MuiInputBase-colorError,.MuiInputBase-colorSuccess)': {
                '.MuiOutlinedInput-notchedOutline': {
                  border: FOCUS_BORDER
                }
              },
              '&.MuiInputBase-colorError,&.MuiInputBase-colorSuccess': {
                fieldset: {
                  legend: {
                    span: {
                      paddingRight: 2
                    }
                  }
                }
              }
            },
            '&.EmbersInput-hasFocus': {
              '&.EmbersInput-hasLabel': {
                '& .Mui-focused': {
                  '&.MuiInputBase-colorError,&.MuiInputBase-colorSuccess': {
                    borderRadius: 2
                  }
                }
              },
              '&.EmbersInput-mini': {
                '& .Mui-focused': {
                  '&.MuiInputBase-colorError,&.MuiInputBase-colorSuccess': {
                    borderRadius: 1
                  }
                }
              },
              // theme dark
              '&.EmbersInput-dark': {
                '&.EmbersInput-error': {
                  '.MuiFilledInput-root': {
                    border: ERROR_BORDER_DARK
                  }
                },
                '&.EmbersInput-success': {
                  '.MuiFilledInput-root': {
                    border: SUCCESS_BORDER_DARK
                  }
                },
                // !mini
                '&.EmbersInput-hasLabel': {
                  '.MuiFilledInput-root': {
                    minHeight: 44,
                    margin: 2,
                    outline: FOCUS_BORDER_DARK,
                    '&.MuiInputBase-adornedEnd': {
                      paddingRight: 11
                    },
                    'input.MuiFilledInput-input': {
                      paddingRight: '14px'
                    }
                  },
                  '&.EmbersInput-error,&.EmbersInput-success': {
                    '.MuiFilledInput-root': {
                      'input.MuiFilledInput-input': {
                        padding: '13px 12px 3px 12px'
                      },
                      '&.MuiInputBase-multiline': {
                        padding: '23px 10px 6px 10px',
                        height: 124
                      },
                      '&.MuiInputBase-adornedEnd': {
                        paddingRight: 10,
                        'input.MuiFilledInput-input': {
                          padding: '13px 14px 3px 12px'
                        }
                      }
                    }
                  },
                  '&:not(.EmbersInput-error,.EmbersInput-success)': {
                    '.MuiFilledInput-root': {
                      border: FOCUS_INNER_BORDER_DARK,
                      borderRadius: 1,
                      'input.MuiFilledInput-input': {
                        padding: '14px 13px 4px 13px'
                      },
                      '&.MuiInputBase-multiline': {
                        padding: '24px 11px 7px 11px',
                        height: 124
                      },
                      '&.MuiInputBase-adornedEnd': {
                        'input.MuiFilledInput-input': {
                          padding: '14px 14px 4px 13px'
                        }
                      }
                    }
                  }
                },
                // mini
                '&.EmbersInput-mini': {
                  '.MuiFilledInput-root': {
                    outline: FOCUS_BORDER_DARK,
                    borderWidth: 1,
                    margin: 2,
                    input: {
                      padding: '1px 5px'
                    },
                    '&.MuiInputBase-adornedEnd': {
                      paddingRight: 7
                    },
                    '&:not(.MuiInputBase-colorSuccess,.MuiInputBase-colorError)': {
                      border: FOCUS_INNER_BORDER_DARK,
                      borderRadius: 1
                    },
                    '&.MuiInputBase-colorSuccess,&.MuiInputBase-colorError': {
                      input: {
                        padding: '1px 6px 1px 5px'
                      }
                    }
                  }
                }
              },
              // theme light
              '&.EmbersInput-light': {
                // !mini
                '&.EmbersInput-hasLabel': {
                  '& .Mui-focused': {
                    '&.MuiInputBase-colorError,&.MuiInputBase-colorSuccess': {
                      input: {
                        padding: '9px 13px',
                        margin: 3
                      },
                      '.MuiOutlinedInput-notchedOutline': {
                        margin: 3
                      }
                    }
                  }
                },
                // mini
                '&.EmbersInput-mini': {
                  '&.EmbersInput-error,&.EmbersInput-success': {
                    border: FOCUS_BORDER,
                    borderRadius: 4,
                    '& .Mui-focused': {
                      '&.MuiInputBase-colorError,&.MuiInputBase-colorSuccess': {
                        margin: 1,
                        paddingRight: 5,
                        input: {
                          padding: '1px 8px 1px 5px'
                        }
                      }
                    }
                  }
                }
              }
            },
            '.MuiFilledInput-root': {
              '&.Mui-focused': {
                border: FOCUS_BORDER
              }
            }
          },
          '&.EmbersInput-mini': {
            '.MuiOutlinedInput-root,.MuiFilledInput-root': {
              '&.MuiFilledInput-root': {
                minHeight: 'unset',
                '&:not(.MuiInputBase-colorError,.MuiInputBase-colorSuccess)': {
                  borderColor: 'transparent'
                }
              },
              '.MuiOutlinedInput-input,.MuiFilledInput-input': _objectSpread(_objectSpread({
                padding: '4px 8px',
                height: 24
              }, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
                color: PROMETHEAN_TEXT_HEADER,
                '&.MuiFilledInput-input': {
                  padding: '2px 6px'
                }
              }),
              fieldset: {
                marginTop: 5,
                legend: {
                  height: 0,
                  span: {
                    display: 'none'
                  }
                }
              },
              '&.MuiInputBase-adornedEnd': {
                paddingRight: 8
              },
              '.EmbersStatusIcon-icon': {
                cursor: 'default'
              }
            }
          }
        }
      }
    },
    // added for the datepicker
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          button: {
            padding: 0,
            margin: 0
          }
        }
      }
    }
  }
});
export var InputContainer = styled('div')({
  position: 'relative',
  '.EmbersInput-notchedOutline': {
    pointerEvents: 'none',
    position: 'absolute',
    width: '100%',
    padding: '0 10px',
    textAlign: 'left',
    top: -4,
    left: -2,
    height: 59,
    border: FOCUS_BORDER,
    borderRadius: 4,
    minWidth: '0%',
    legend: {
      color: 'transparent',
      fontSize: 12,
      lineHeight: '24px',
      padding: 0,
      letterSpacing: '0.15px',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
      span: {
        padding: '0px 5px',
        fontWeight: 400,
        paddingRight: 2
      }
    },
    '&-multiline': {
      height: 131,
      legend: {
        letterSpacing: '0.32px'
      }
    }
  },
  '&.EmbersInput-required': {
    '.EmbersInput-notchedOutline': {
      legend: {
        span: {
          paddingLeft: 1.7
        }
      }
    }
  }
});